import * as $runtime from "../runtime.js";
import * as Data$dLeibniz from "../Data.Leibniz/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Partial from "../Partial/index.js";
const $Value = (tag, _1) => ({tag, _1});
const NoValue = value0 => $Value("NoValue", value0);
const SomeValue = value0 => $Value("SomeValue", value0);
const showValue = dictShow => (
  {
    show: v => {
      if (v.tag === "NoValue") { return "noValue"; }
      if (v.tag === "SomeValue") { return "(SomeValue " + dictShow.show(v._1) + ")"; }
      $runtime.fail();
    }
  }
);
const functorValue = {
  map: f => m => {
    if (m.tag === "NoValue") { return $Value("NoValue", m._1); }
    if (m.tag === "SomeValue") { return $Value("SomeValue", f(m._1)); }
    $runtime.fail();
  }
};
const eqValue = dictEq => (
  {
    eq: x => y => {
      if (x.tag === "NoValue") { return y.tag === "NoValue"; }
      if (x.tag === "SomeValue") {
        if (y.tag === "SomeValue") { return dictEq.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  }
);
const applyValue = {
  apply: v => v1 => {
    if (v.tag === "NoValue") { return $Value("NoValue", v._1); }
    if (v1.tag === "NoValue") { return $Value("NoValue", v1._1); }
    if (v.tag === "SomeValue") {
      if (v1.tag === "SomeValue") { return $Value("SomeValue", v._1(v1._1)); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Functor0: () => functorValue
};
const bindValue = {
  bind: v => v1 => {
    if (v.tag === "NoValue") { return $Value("NoValue", v._1); }
    if (v.tag === "SomeValue") { return v1(v._1); }
    $runtime.fail();
  },
  Apply0: () => applyValue
};
const applicativeValue = {pure: SomeValue, Apply0: () => applyValue};
const monadValue = {Applicative0: () => applicativeValue, Bind1: () => bindValue};
const toMaybe = v => {
  if (v.tag === "NoValue") { return Data$dMaybe.Nothing; }
  if (v.tag === "SomeValue") { return Data$dMaybe.$Maybe("Just", v._1); }
  $runtime.fail();
};
const encodeValue = dictEncode => (
  {
    encode: x => {
      if (x.tag === "NoValue") { return Foreign$dNullOrUndefined.nullImpl; }
      if (x.tag === "SomeValue") { return dictEncode.encode(x._1); }
      $runtime.fail();
    }
  }
);
const orElse = v => v1 => {
  if (v.tag === "SomeValue") { return $Value("SomeValue", v._1); }
  if (v.tag === "NoValue") { return v1; }
  $runtime.fail();
};
const noValue = /* #__PURE__ */ $Value("NoValue", Data$dLeibniz.refl);
const unsafeNoValue = /* #__PURE__ */ $Value("NoValue", Data$dLeibniz.refl);
const $$get = v => {
  if (v.tag === "NoValue") { return Partial._crashWith("You broke the universe!"); }
  if (v.tag === "SomeValue") { return v._1; }
  $runtime.fail();
};
const elim = v => v1 => v2 => {
  if (v2.tag === "NoValue") { return v(v2._1); }
  if (v2.tag === "SomeValue") { return v1(v2._1); }
  $runtime.fail();
};
export {
  $Value,
  NoValue,
  SomeValue,
  applicativeValue,
  applyValue,
  bindValue,
  elim,
  encodeValue,
  eqValue,
  functorValue,
  $$get as get,
  monadValue,
  noValue,
  orElse,
  showValue,
  toMaybe,
  unsafeNoValue
};
